import request from '@/utils/request'

export function loginByUsername(username, password) {
  const data = {
    username,
    password,
  }
  return request({
    url: '/api/public/login',
    method: 'post',
    data
  })
}

//新增客户企业信息(激活建议)
export function collectionCorp(data) {
  return request({
    url: '/api/public/collectionCorp',
    method: 'post',
    data
  })
}

export function logout() {
  return request({
    url: '/api/v2/logout',
    method: 'get'
  })
}

export function getUserInfo(data) {
  return request({
    url: '/api/v2/userInfo',
    method: 'post',
    data
  })
}

export function updatePeriod(data) {
  return request({
    url: '/api/v2/updatePeriod',
    method: 'post',
    data
  })
}

export function sendSms(data) {
  return request({
    url: '/api/v2/sendSms',
    method: 'post',
    data
  })
}